import { ProductId } from "../material-ui/NavigatorData";

export const AUTH_CONFIG = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN!,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID!,
  clientSecret: process.env.REACT_APP_AUTH0_CLIENT_SECRET!,
  callbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL,
  redirectUrl: process.env.REACT_APP_AUTH0_REDIRECT_URL
};

export interface AuthProduct {
  clientId: string | undefined,
  clientSecret: string | undefined,
  callbackUrl: string | undefined,
  downloadTokenName: string
}

export interface AuthProductCollection {
  [ProductId.ccS1000D]: AuthProduct,
  [ProductId.ccJATS]: AuthProduct,
  [ProductId.ccBITS]: AuthProduct,
  [ProductId.ccNISOSTS]: AuthProduct,
  [ProductId.ccXSLFO]: AuthProduct
}

export const AUTH_PRODUCT_CONFIG: AuthProductCollection = {
  [ProductId.ccS1000D]: {
    clientId: process.env.REACT_APP_CC_S1000D_AUTH0_CLIENT_ID!,
    clientSecret: process.env.REACT_APP_CC_S1000D_AUTH0_CLIENT_SECRET!,
    callbackUrl: process.env.REACT_APP_CC_S1000D_CALLBACK_URL,
    downloadTokenName: "deltaxml-content-compare-s1000d-token.json"
  },
  [ProductId.ccJATS]: {
    clientId: process.env.REACT_APP_CC_JATS_AUTH0_CLIENT_ID!,
    clientSecret: process.env.REACT_APP_CC_JATS_AUTH0_CLIENT_SECRET!,
    callbackUrl: process.env.REACT_APP_CC_JATS_CALLBACK_URL,
    downloadTokenName: "deltaxml-content-compare-jats-token.json"
  },
  [ProductId.ccBITS]: {
    clientId: process.env.REACT_APP_CC_BITS_AUTH0_CLIENT_ID!,
    clientSecret: process.env.REACT_APP_CC_BITS_AUTH0_CLIENT_SECRET!,
    callbackUrl: process.env.REACT_APP_CC_BITS_CALLBACK_URL,
    downloadTokenName: "deltaxml-content-compare-bits-token.json"
  },  
  [ProductId.ccNISOSTS]: {
    clientId: process.env.REACT_APP_CC_NISOSTS_AUTH0_CLIENT_ID!,
    clientSecret: process.env.REACT_APP_CC_NISOSTS_AUTH0_CLIENT_SECRET!,
    callbackUrl: process.env.REACT_APP_CC_NISOSTS_CALLBACK_URL,
    downloadTokenName: "deltaxml-content-compare-nisosts-token.json"
  },
  [ProductId.ccXSLFO]: {
    clientId: process.env.REACT_APP_CC_XSLFO_AUTH0_CLIENT_ID!,
    clientSecret: process.env.REACT_APP_CC_XSLFO_AUTH0_CLIENT_SECRET!,
    callbackUrl: process.env.REACT_APP_CC_XSLFO_CALLBACK_URL,
    downloadTokenName: "deltaxml-content-compare-xslfo-token.json"
  }
}

export const SAAS_AUTH_SETTINGS = {
  responseType: "token id_token",
  scope: "openid email offline_access"
}